import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import moment from 'moment';

import { addStore } from 'common/util';
import FieldFactory from 'common/components/field-factory';

import SongOptions from './song-options';

@inject('songsStore', 'formStore', 'albumsStore', 'statsStore')
@observer
class SongRow extends Component {
	constructor (props) {
		super(props);

		const { songsStore, formStore } = this.props;
		this.FieldWithStore = addStore(FieldFactory, { store: songsStore, formStore });
	}

	componentDidMount () {
		const { song } = this.props;
		this.checkboxRef.checked = song.explicit;
		this.songTitleRef.setAttribute('contentEditable', true);
	}

	render () {
		const FieldWithStore = this.FieldWithStore;
		const { songID, songsStore, albumsStore, optionsTheme } = this.props;
		const song = songsStore.getSongByID(songID);
		const addedDate = moment(new Date(song.dateAdded), 'YYYYMMDD').fromNow();
		const _id = song._id;
		const checkboxID = `title-${_id}`;
		const songIndex = songsStore.getItemIndex(song);
		const classList = ['grid-x', 'align-justify', 'align-middle', 'song-row'];
		const albums = albumsStore.getAlbumsForSong(song);

		if (_id === songsStore.activeSongRowID) {

			classList.push('active');
		}

		return (
			<div className={ classList.join(' ') }>
				<div className="cell shrink">
					<div className="song-row-counter" data-full-preview-position={ song.fullPreviewPosition }>
						<span className="fas fa-play-circle" onClick={ this.onPlayClick }></span>
					</div>
				</div>
				<div className="cell auto">
					<div
						className="inline"
						data-key="title"
						ref={ (node) => this.songTitleRef = node }
						onBlur={ this.onEditableBlur }>{ song.title }</div>
				</div>

				<div className="cell small-4">
					<span>{ albums.map(({ name }) => name).join(', ') }</span>
				</div>

				<div className="cell small-1 text-center">
					{ songsStore.formatDuration(song) }
				</div>

				<div className="cell small-1 text-center">
					<div>
						<input
							type="checkbox"
							data-key="explicit"
							_id={ checkboxID }
							ref={ (node) => this.checkboxRef = node }
							onChange={ this.onCheckboxChange } />
					</div>
				</div>

				<div className="cell small-1 text-center">
					{ song.plays || 0 }
				</div>

				<div className="cell small-1 text-center">
					{ song.hifives || 0 }
				</div>

				<SongOptions songID={ song._id } song={ song } optionsTheme={ optionsTheme } />
			</div>
		);
	}

	@autobind
	onPlayClick () {
		const { songID } = this.props;
		this.props.songsStore.currentSongPlayback = songID;
	}

	@autobind
	onDeleteClick () {
		const { songsStore, songID } = this.props;
		songsStore.deleteItem(songsStore.getSongByID(songID));
	}

	@autobind
	onCheckboxChange ({ target }) {
		const { dataset, checked } = target;
		this.updateField(dataset.key, checked);
	}

	@autobind
	onEditableBlur ({ target }) {
		const { innerHTML, dataset } = target;
		this.updateField(dataset.key, innerHTML);
	}

	@autobind
	onAlbumChange ({ target }) {
		const { value } = target;
		this.updateField('albumIDs', value);
	}

	updateField (key, value) {
		const { songsStore, statsStore, songID: _id } = this.props;
		songsStore.updateSong({ _id, key, value });
		statsStore.fetchStats();
	}
}

export default SongRow;
